import { render } from "./ManualBurnRestrictionsView.vue?vue&type=template&id=24ccaf83"
import script from "./ManualBurnRestrictionsView.vue?vue&type=script&lang=js"
export * from "./ManualBurnRestrictionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__